module.exports = __webpack_public_path__ + "img/key.d88c7164.svg";